import { api } from 'api';
import { AxiosPromise } from 'axios';
import { PlansData } from 'features/subscription/ts/SubscriptionPlans';

export const getAllPlansData = (): AxiosPromise<PlansData[]> => api.get(`/partners/subscription/plans/`);

export const redirectCheckoutSession = (payload: string): AxiosPromise<{ url: string }> =>
  api.post(`/partners/subscription/create-checkout-session/`, { price_id: payload });

export const redirectPortalSession = (): AxiosPromise<{ url: string }> =>
  api.post(`partners/subscription/create-portal-session/`);
